<template>
    <b-modal :title="hotel.title" class="modal-primary" size="xl"  v-model="showModalLocal" ok-variant="primary"  @hide="handleHide" v-if="isHotelLoaded()">
        <b-tabs nav-wrapper-class="w-40">
            <b-tab active>
                <template slot="title">
                    <i class="icon-calculator"></i> Общие данные
                </template>

                <div class="images-block">
                    <div v-for="img in hotelImages()">
                        <img :src="img.tn_url" alt="" >
                    </div>
                </div>

                <div v-html="hotel.content_html_general"></div>
                <p>
                    Заезд: {{hotel.time_check_in}}. Выезд: {{hotel.time_check_out}}. Расчетный час: {{hotel.time_check_payment}}<br>
                    <strong>Вознаграждение агентства</strong>: {{ agencyFee  }} %<br>
                </p>

                <template v-if="is_agent_or_agency | is_admin | is_manager_or_buh">
                    <h5>Дополнительная информация (для агентств)</h5>

                    <div v-html="hotel.info_other">
                    </div>
                </template>


                <div v-if="services_ok.length">
                    <h5>Услуги/Сервисы</h5>
                    <ul>
                        <li v-for="s in services_ok">{{s.title}} &nbsp; <small>{{s.description}}</small></li>
                    </ul>
                </div>

            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-home"></i> Проживание
                </template>
                <div v-html="hotel.content_html_rooms"></div>

                <div v-if="_rooms.length">
                    <h5>Номера</h5>
                    <ul>
                        <li v-for="r in _rooms">{{r.title}}</li>
                    </ul>
                </div>

            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-apple"></i> Питание
                </template>
                <div v-html="hotel.content_html_diet"></div>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-soccer-ball-o"></i> Досуг
                </template>
                <div v-html="hotel.content_html_leisure"></div>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-medkit"></i> Лечение
                </template>

                <div v-html="hotel.content_html_healing"></div>

                <div v-if="diseases_ok.length">
                    <h5>Заболевания</h5>
                    <ul>
                        <li v-for="s in diseases_ok">{{s.title}} &nbsp; <small>{{s.description}}</small></li>
                    </ul>
                </div>

            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="cui-dollar"></i> Программы
                </template>

                <div v-if="programs_ok.length">
                    <b-card no-body class="mb-1"  v-for="t in programs_ok" :key="t.id">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle="'collapse_inner'+t.id" variant="primary">{{t.title}}</b-btn>
                        </b-card-header>
                        <b-collapse :id="'collapse_inner'+t.id" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <div v-html="t.content_html"></div>
                                <template v-if="is_prices_loaded">
                                    <prices-table
                                            :hotel="hotel"
                                            :prices="prices"
                                            :filterroomid="0"
                                            :filterprogramid="t.id"
                                            :mode="'program'"
                                    ></prices-table>
                                </template>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>

            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="cui-dollar"></i>  Номера и Цены
                </template>

                <div v-if="_rooms.length">
                    <b-card no-body class="mb-1"  v-for="r in _rooms" :key="r.id">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle="'collapse_inner'+r.id" variant="primary">{{r.title}}</b-btn>
                        </b-card-header>
                        <b-collapse :id="'collapse_inner'+r.id" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>

                                <div class="images-block">
                                    <div v-for="img in roomImages(r.id)">
                                        <img :src="img.tn_url" alt="" >
                                    </div>
                                </div>

                                <div v-html="r.content_html"></div>
                                <template v-if="is_prices_loaded">
                                    <prices-table
                                            :hotel="hotel"
                                            :prices="prices"
                                            :filterroomid="r.id"
                                            :filterprogramid="0"
                                            :mode="'room'"
                                        ></prices-table>
                                </template>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-tab>


            <b-tab>
                <template slot="title">
                    <i class="icon-pie-chart"></i> Квоты
                </template>

                <b-button variant="primary" @click="onShowQuotas()">  <i class="fa fa-refresh" ></i>  {{isQuotasLoaded()?'Обновить квоты':'Показать квоты'}}</b-button>
                <br/><br/>
                <div class="flex-form" v-if="isQuotasLoaded()">
                    <p v-if="quotas.otherrooms && quotas.otherrooms.length">Кроме приведенных в таблице имеются другие квоты, которые не могут быть
                        показаны так как нет привязки к номерам НСБ. Обратитесь к операторам, ответственным за связку данных
                        объекта и данных НСБ ({{quotas.otherrooms}}).</p>
                </div>
                <table  style="width:100%;" v-if="isQuotasLoaded()"  class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed">
                    <tr>
                        <td v-for="(s,i) in quotas.dates" :key="i">{{s.slice(8, 10)}}.{{s.slice(5, 7)}}</td>
                    </tr>
                    <template v-for="room in quotas.rooms">
                        <tr>
                            <td :colspan="Object.keys(quotas.dates).length">
                                {{ getRoomTitleById(room.id, rooms) }} (<span v-if="room.pk">профкурорт</span><span v-if="!room.pk">НСБ</span>)
                            </td>
                        </tr>
                        <tr>
                            <td v-for="(s,i) in room.data" :key="i" :style="s?'alert-success':'alert-danger'">{{s}}</td>
                        </tr>
                    </template>
                </table>

                <template v-if="hotel_quotas">
                    <table class="table table-bordered table-sm table hovered">
                        <tr>
                            <th>Номер</th>
                            <th>С</th>
                            <th>До</th>
                            <th>№</th>
                            <template v-if="is_agent_plus | is_admin | is_manager_or_buh">
                                <th>
                                    Агент
                                </th>
                            </template>
                            <th>тип</th>
                        </tr>
                        <tr v-for="quota in hotel_quotas">
                            <td>{{ quota.room_title }}</td>
                            <td>{{ printDate(quota.begin_at) }}</td>
                            <td>{{printDate( quota.end_at) }}</td>
                            <td>
                                {{ quota.voucher_id }}
                            </td>
                            <template v-if="is_agent_plus | is_admin | is_manager_or_buh">
                                <td>
                                    {{ quota.voucher.user.surname }} {{ quota.voucher.user.name_ }}
                                </td>
                            </template>
                            <td>{{ quota.type }}</td>
                        </tr>
                    </table>
                </template>

                <b-alert show variant="danger" v-if='isNoQuotas() && !hotel_quotas'>
                    {{ no_quotas }}
                </b-alert>
            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-percent"></i> Скидки
                </template>

                <table class="table table-bordered table-hover table-sm">
                    <tr>
                        <th class="text-center" rowspan="2">№</th>
                        <th class="text-center" rowspan="2">Название и условия</th>
                        <th class="text-center" colspan="2">Период продажи</th>
                        <th class="text-center" colspan="2">Период путевки</th>
                        <th class="text-center" colspan="3">Скидка</th>
                    </tr>
                    <tr>
                        <th class="text-center">Дата начала</th>
                        <th class="text-center">Дата окончания</th>
                        <th class="text-center">Дата заезда</th>
                        <th class="text-center">Дата выезда</th>
                        <th class="text-center">%</th>
                        <th class="text-center">сумма</th>
                        <th class="text-center">дней</th>
                    </tr>
                    <tr v-for="d in discounts">
                        <td class="text-center">{{ d.id }}</td>
                        <td class="text-center"><h6>{{ d.title }}<template v-if="d.social"> (социальная)</template></h6> <span v-html="discountCoditions(d)"></span> </td>
                        <td class="text-center">{{ printDate(d.sale_start_at) }}</td>
                        <td class="text-center">{{ printDate(d.sale_end_at) }}</td>
                        <td class="text-center">{{ printDate(d.start_at) }}</td>
                        <td class="text-center">{{ printDate(d.end_at) }}</td>
                        <td class="text-center">{{ d.value_percent }}</td>
                        <td class="text-center">{{ formatPriceKop(d.value_fixed) }}</td>
                        <td class="text-center">{{ d.value_days }}</td>
                    </tr>
                </table>

            </b-tab>

        </b-tabs>

        WID=28dbdb4c-7100-4063-8430-af338abde238

        <br/>

        <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Закрыть
            </b-button>
        </template>
    </b-modal>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_price } from '@/functions_price';
    import { functions_discount } from '@/functions_discount';
    import { functions_hotel } from '@/functions/hotel';
    import { functions_room } from '@/functions_room';

    import PricesTable from '@/components/PricesTable';

    export default {
        name: 'HotelInfoDialog',
        mixins: [functions, functions_loaders, functions_discount, functions_price, functions_hotel, functions_room],
        data: function () {
            return {
                showModalLocal: this.showModal
            };
        },
        components: {
            PricesTable
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            hotelid: [Number],
        },
        watch: {
            showModal: function () {
                if (this.hotelid && this.hotelid!==null) {
                    this.resetHotel().loadHotel(this.hotelid);
                    this.resetPrices().loadPricesForHotel(this.hotelid);
                    this.resetDiscounts().loadDiscounts(this.hotelid);
                    this.showModalLocal = true;
                }
                else {
                    this.resetHotel();
                }
            }
        },
        methods: {
            handleHide: function () {
                this.$emit("hide", false);
            },
            onShowQuotas:function () {
                if (!this.isHotelLoaded()) return false;
                this.resetQuotas().loadQuotas(this.hotel.id, new Date(), new Date());
            },
            imagesFiltrator: function(room_id) {
                return function(element) {
                    return element.room_id === room_id;
                }
            },
            roomImages: function(room_id) {
                return this.hotel.images.filter(this.imagesFiltrator(room_id));
            },
            hotelImages: function() {
                return this.hotel.images.filter(this.imagesFiltrator(null));
            },
        },
        computed: {
            agencyFee: function() {
                let agencyFee = this.hotel.procent_ref_obj - this.hotel.sys_commission_obj_procent - this.companyCommission;
                if (this.is_admin)
                    return this.hotel.procent_ref_obj + ' - ' + this.hotel.sys_commission_obj_procent + ' - ' + this.companyCommission + ' = ' + agencyFee;
                else
                    return agencyFee
            },
            _rooms: function() {
                return this.hotel.rooms;
            },
            periods_ok: function() {
                return this.hotel.periods;
            },
            programs_ok: function() {
                return this.hotel.programs;
            },
            services_ok: function() {
                return this.hotel.services;
            },
            diseases_ok: function() {
                return this.hotel.diseases;
            },
        }
    }
</script>


<style>
    .images-block {
        display: flex;
        overflow-x:scroll;
    }

    .images-block div{
        flex: 1;
        margin:3px;
        padding:3px;
        border:solid 1px #CCC;
        width:128px;
        height:128px;
    }

    .images-block div img{
        width:120px;
        height:120px;
    }
</style>
